enum ProductType {
  Thermostat = "thermostat",
  ThermostatV2 = "thermostatV2",
  CWA = "cwa",
  THS = "ths",
  WLS = "wls",
}

export default ProductType
